import { AxiosResponse } from "axios";
import { useQuery } from "react-query";

import axios from "libs/Axios";
import { AxiosDefaultErrorEntity } from "types/api/Common/ErrorTypes";
import {
  TenantKpiDisplayResponse,
  TenantKpiListItem,
} from "types/api/Tenant/KpiTypes";

export const TENANT_KPI_QUERY_KEY = {
  LIST: "TENANT_KPI_LIST",
  DISPLAY: "TENANT_KPI_DISPLAY",
};

export function useGetTenantKpiList() {
  return useQuery<AxiosResponse<TenantKpiListItem[]>, AxiosDefaultErrorEntity>(
    [TENANT_KPI_QUERY_KEY.LIST],
    () => axios.get("/api/v1/tenant/kpi/list").then((res) => res)
  );
}

export function useGetTenantKpiDisplay(
  kpiDefinitionId?: string,
  currentTimePeriod?: string
) {
  return useQuery<
    AxiosResponse<TenantKpiDisplayResponse>,
    AxiosDefaultErrorEntity
  >(
    [TENANT_KPI_QUERY_KEY.DISPLAY, kpiDefinitionId, currentTimePeriod],
    () => {
      const url = `/api/v1/tenant/kpi/display/${kpiDefinitionId}`;
      return currentTimePeriod
        ? axios.get(url, { params: { currentTimePeriod } }).then((res) => res)
        : axios.get(url).then((res) => res);
    },
    { enabled: Boolean(kpiDefinitionId) }
  );
}
